import { useNavigate } from 'react-router-dom';
import { PageContainer } from '@/components/layout/PageContainer';
import { SEO } from '@/components/seo/SEO';
import { CANONICAL_URLS } from '@/utils/canonicalUrl';

export function SignupSelectPage() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleBuyerSignup = () => {
    navigate('/signup/buyer');
  };

  const handleSellerSignup = () => {
    navigate('/signup/seller');
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="회원가입 선택 - 에코딜"
        description="에코딜 회원가입을 시작하세요. 구매자 또는 판매자 유형을 선택해주세요."
        canonical={CANONICAL_URLS.SIGNUP_SELECT}
      />
      <PageContainer>
        {/* 헤더 */}
        <div className="flex items-center justify-center relative mb-20">
          <button
            onClick={handleBack}
            className="absolute left-0 p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <img
              src="/icons/icon_back.svg"
              alt="뒤로가기"
              className="w-6 h-6"
            />
          </button>
          <h1 className="text-2xl font-bold text-[#222222]">회원가입</h1>
        </div>

        {/* 질문 */}
        <div className="text-center mb-16">
          <h2 className="text-xl font-semibold text-[#222222]">
            에코딜에서 무엇을 하고 싶으신가요?
          </h2>
        </div>

        {/* 선택 버튼들 */}
        <div className="max-w-[300px] mx-auto">
          <button
            onClick={handleBuyerSignup}
            className="w-full h-[64px] bg-[#CCEFCC] text-[#222222] font-semibold text-xl rounded-xl hover:bg-[#B5E5B5] transition-colors"
          >
            사고 싶어요 (일반 소비자)
          </button>

          <div className="h-[56px]"></div>

          <button
            onClick={handleSellerSignup}
            className="w-full h-[64px] bg-[#FFEFE0] text-[#222222] font-semibold text-xl rounded-xl hover:bg-[#FFE5CC] transition-colors"
          >
            팔고 싶어요 (점주 사장님)
          </button>
        </div>
      </PageContainer>
    </div>
  );
}